// @flow

import $ from 'jquery'

import { HOST } from './constants/foxford'

/**
 * Зачастую, изначально, всем показываем полную ссылку https://foxford.ru/user/login?redirect_url=, но если
 * пользователь авторизирован и переходит по такой ссылке, то у него всплывает уведомление "Вы уже авторизированы"
 * Чтобы этого не было, нужно для авторизированого пользователя убрать эту часть из ссылки
 * Например при отправке пользователя на лендинги мини-групп необходимо идти через авторизаци/регистрацию,
 * но есть и другие подобные кейсы
 */
export const removeAuthInLink = () => {
  const enrollBtns = $(`a[href*="${HOST}/user/login?redirect_url="]`)
  const enrollBtnsWithHash = $('a[href*="%23"]')

  enrollBtns.each((_, item) => {
    const href = $(item).attr('href')
    $(item).attr('href', `${href.replace(`${HOST}/user/login?redirect_url=`, '')}`)
  })

  enrollBtnsWithHash.each((_, item) => {
    const href = $(item).attr('href')
    $(item).attr('href', `${href.replace('%23', '#')}`)
  })
}
